import FilledButtonM from "@common/components/button/FilledButtonM"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { apiRequest } from "@data/redux/actions/api"
import { hideResetModal } from "@data/redux/actions/tutorMonthlyScore"
import { tutorMonthlyScoreService } from "@data/services/tutorMonthlyScoreService"
import moment from "moment"
import React, { useContext } from "react"
import { ScrollView, View } from "react-native"
import { connect } from "react-redux"
import { DimensionsContext } from "../../common/utils/mobileUtils"
import { ChampionImageM } from "../../student/champions/ChampionImageM"

const TutorRankingResetModal = (props) => {
    const { visible, onDismiss, scoreData } = props

    const handleClose = () => {
        // Mark modal as shown using POST endpoint
        props.apiRequest(tutorMonthlyScoreService.markResetModalShown)
        props.hideResetModal()
        if (onDismiss) {
            onDismiss()
        }
    }

    if (!visible || !scoreData) {
        return null
    }

    const dimensions = useContext(DimensionsContext)
    const width = dimensions?.width > 800 ? "70%" : "95%"

    const rank = scoreData?.rank
    const isTopThree = rank && rank <= 3

    const currentMonth = moment().format("YYYY-MM")

    //TODO: remove this after
    const isNovember2025 = currentMonth === "2025-11"

    const performanceScore = scoreData?.performance_score
    const displayScore =
        performanceScore != null ? (performanceScore * 100).toFixed(0) : "-"

    return (
        <ModalM
            visible={visible}
            onDismiss={handleClose}
            dismissable={true}
            style={{ width, maxHeight: "95%" }}
        >
            <ScrollView
                style={{
                    maxHeight: dimensions?.height * 0.85,
                }}
                contentContainerStyle={{
                    padding: 24,
                    alignItems: "center",
                }}
            >
                {/* Champion Image */}
                <ChampionImageM
                    name="abou"
                    variant="happy"
                    width={100}
                    style={{ marginBottom: 16 }}
                />

                {/* Title */}
                <TextM
                    fontWeight={"Bold"}
                    fontSize={24}
                    color={theme.colors.primary}
                    style={{ textAlign: "center", marginBottom: 8 }}
                    wrap
                >
                    Nouveau Mois, Nouveau Départ !
                </TextM>

                {/* Rank Display */}
                <View
                    style={{
                        backgroundColor: isTopThree
                            ? theme.colors.success + "11"
                            : theme.colors.primary + "11",
                        padding: 16,
                        borderRadius: 12,
                        alignItems: "center",
                        width: "100%",
                        marginTop: 16,
                        marginBottom: 16,
                    }}
                >
                    <TextM
                        fontSize={40}
                        fontWeight={"Bold"}
                        color={
                            isTopThree
                                ? theme.colors.success
                                : theme.colors.primary
                        }
                    >
                        #{rank || "-"}
                    </TextM>
                    <TextM
                        fontSize={13}
                        color={theme.colors.grey}
                        style={{ marginTop: 4 }}
                        wrap
                    >
                        Classement du mois dernier
                    </TextM>
                    <TextM
                        fontSize={15}
                        fontWeight={"SemiBold"}
                        color={theme.colors.primary}
                        style={{ marginTop: 6 }}
                    >
                        Score: {displayScore}%
                    </TextM>
                </View>

                {/* Message based on ranking */}
                {isTopThree ? (
                    <View
                        style={{
                            backgroundColor: theme.colors.success + "22",
                            padding: 14,
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: theme.colors.success,
                            marginBottom: 16,
                        }}
                    >
                        <TextM
                            fontSize={16}
                            fontWeight={"Bold"}
                            color={theme.colors.success}
                            style={{ textAlign: "center", marginBottom: 8 }}
                            wrap
                        >
                            🎉 Félicitations ! 🎉
                        </TextM>
                        <TextM
                            fontSize={14}
                            color={theme.colors.grey}
                            style={{ textAlign: "center", lineHeight: 20 }}
                            wrap
                        >
                            {isNovember2025 ? (
                                <>
                                    Tu fais partie du Top 3 ! Excellent travail.
                                    Continue sur cette lancée pour maintenir ton
                                    niveau d'excellence ! 🚀
                                </>
                            ) : (
                                <>
                                    Tu fais partie du Top 3 ! Tu gagnes{" "}
                                    <TextM
                                        fontWeight={"Bold"}
                                        color={theme.colors.success}
                                    >
                                        3€ de bonus par heure de live
                                    </TextM>{" "}
                                    pendant les deux prochaines semaines.
                                    Continue comme ça ! 🚀
                                </>
                            )}
                        </TextM>
                    </View>
                ) : (
                    <View
                        style={{
                            backgroundColor: theme.colors.info + "11",
                            padding: 14,
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: theme.colors.info,
                            marginBottom: 16,
                        }}
                    >
                        <TextM
                            fontSize={16}
                            fontWeight={"Bold"}
                            color={theme.colors.primary}
                            style={{ textAlign: "center", marginBottom: 8 }}
                            wrap
                        >
                            💪 Vise le Top 3 !
                        </TextM>
                        <TextM
                            fontSize={14}
                            color={theme.colors.grey}
                            style={{ textAlign: "center", lineHeight: 20 }}
                            wrap
                        >
                            Les tuteurs du Top 3 gagnent{" "}
                            <TextM
                                fontWeight={"Bold"}
                                color={theme.colors.primary}
                            >
                                3€ de bonus par heure de session
                            </TextM>{" "}
                            pendant deux semaines. Améliore ton score ce mois-ci
                            pour décrocher cette récompense ! 🎯
                        </TextM>
                    </View>
                )}

                {/* CTA Button */}
                <FilledButtonM
                    onPress={handleClose}
                    label="C'est parti ! 🚀"
                    color={theme.colors.primary}
                    style={{
                        width: "100%",
                        borderRadius: 12,
                        marginTop: 8,
                    }}
                />
            </ScrollView>
        </ModalM>
    )
}

const mapStateToProps = (state) => ({
    visible: state.data.tutorMonthlyScore?.shouldShowResetModal || false,
    scoreData: state.data.tutorMonthlyScore?.previousMonthScore,
})

const mapDispatchToProps = {
    hideResetModal,
    apiRequest,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TutorRankingResetModal)
